import { serializeObject } from "../common/helper";
import { Request } from "../services/HttpService";
export const TechnologyCategoryService = {
  getAll() {
    return Request("vitae/technologycategory", "GET");
  },
  getAllPaginated(pageSise, pageNumber, searchObject) {
    return Request(
      `vitae/technologyCategory/${pageSise}/${pageNumber}?${serializeObject(
        searchObject
      )}`,
      "GET"
    );
  },
  getById(id) {
    return Request(`vitae/technologyCategory/${id}`, "GET");
  },
  createOrUpdate(technologyCategory) {
    return Request(
      `vitae/technologyCategory`,
      technologyCategory.id ? "PUT" : "POST",
      technologyCategory
    );
  },
  deleteCategory(technologyCategoryId) {
    return Request(
      `vitae/technologycategory/${technologyCategoryId}`,
      "DELETE"
    );
  }
};
